/**
 * PIN gate.
 *
 * This keeps a passer-by out of an open laptop. It is not encryption — the
 * data is still readable by anyone with access to the machine or the database,
 * and the Security pane says so.
 */
import { useState, useRef, useEffect } from 'react';
import { useApp } from '../store/AppContext.jsx';

export default function LockScreen() {
  const { tryUnlock } = useApp();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);

  const submit = () => {
    if (tryUnlock(pin)) { setPin(''); setError(''); return; }
    setError('That PIN is not right.');
    setPin('');
    inputRef.current?.focus();
  };

  return (
    <div className="lock open">
      <div className="lockbox">
        <div className="ic g-purple">&#128274;</div>
        <h3>Workspace locked</h3>
        <p>Enter your PIN to carry on.</p>
        <input
          ref={inputRef}
          type="password"
          placeholder="••••"
          inputMode="numeric"
          value={pin}
          onChange={e => setPin(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') submit(); }}
        />
        <div className="lockmsg">{error}</div>
        <button
          type="button"
          className="btn primary"
          style={{ width: '100%', justifyContent: 'center', marginTop: 10 }}
          onClick={submit}
        >
          Unlock
        </button>
      </div>
    </div>
  );
}
